import React, { useState, useMemo, useEffect } from "react";
import PostHeader from "./PostHeader/PostHeader";
import PostContent from "./PostContent/PostContent";
import { useHistory } from "react-router-dom";
import GeneralService from "services/GeneralService";

function SearchPost({ post }) {
  const color = (post?.data?.color ?? { name: "white" }).name.toLowerCase();
  const history = useHistory();
  const [listId, setListId] = useState();
  const color_gradient = post?.data?.color?.color_gradient ?? ["#fff"];
  const textColor = color === "white" ? "#575F6B" : "white";
  const [convertIdToType] = useState({
    1: "status",
    6: "slideshow",
    8: "celebration",
    9: "brightidea",
    10: "topic",
    11: "teamvideo",
    15: "poll",
    16: "todo-list",
    17: "todo-list-item",
  });
  const [postType] = useState(convertIdToType[post?.type_id] ?? 1);

  useEffect(() => {
    if (post?.type_id !== 17) return;

    (async () => {
      try {
        var response = await GeneralService.getTodoListItemId(
          post?.team?.id,
          post?.id
        );

        setListId(response.data.data.todo_list_id);
      } catch (e) {
        console.log(e);
      }
    })();
  }, [post]);

  const idToString = useMemo(() => {
    if ([1, 6, 7, 8, 9, 10, 11, 12].includes(post?.type_id)) return "post";
    if (post?.type_id === 16) return "todo-list";
    return "poll";
  }, [post]);

  const itemContainerStyles = {
    background:
      post.type === "welcomemessage"
        ? "linear-gradient(#00A3A3, #8AFFFF)"
        : `linear-gradient(0deg, ${
            color_gradient[1] ?? color_gradient[0]
          } 0%, ${color_gradient[0]} 80%)`,
    color: post.type === "welcomemessage" ? "white" : textColor,
    fill: textColor,
    borderRadius: "6px",
    padding: "20px",
  };

  const redirectPost = () => {
    if (post?.type_id === 15) {
      history.push({
        pathname: `/teams/${post?.team?.id}/${idToString}/${post?.id}/detail`,
        state: { status: true },
      });
      return;
    }

    if (post?.type_id === 17) {
      history.push({
        pathname: `/teams/${post?.team?.id}/todo-list/${listId}/todo-list-item/${post?.id}`,
      });
      return;
    }

    history.push(`/teams/${post?.team?.id}/${idToString}/${post?.id}`);
  };

  return (
    <div className="maxWidthAdjustment searchPosts clickable">
      <div style={itemContainerStyles} onClick={redirectPost}>
        <PostHeader post={{ ...post, type: postType }} color={color} />
        <PostContent post={post} />
      </div>
    </div>
  );
}

export default SearchPost;
